export default __webpack_public_path__ + "static/media/element_spec_67.96eb1f90.jpg";